import React from 'react';

const AuthHeader = ({ title, subtitle }) => {
  return (
    <div className="text-center mb-8">
      <img 
          src="/logo-light.png" 
          alt="Hunar Pool" 
          className="h-12 w-auto mx-auto" 
          draggable="false"
      />      
      <p className="text-white/80 mt-4">AI-Powered Recruitment Platform</p>
      {title && <h2 className="text-2xl text-white font-bold text-gray-800 text-center mt-6 mb-2">{title}</h2>}
      {subtitle && <p className="text-gray-100 text-center mb-8">{subtitle}</p>}
    </div>
  );
};

export default AuthHeader;